/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'app/utils/loadable';

export const TeamsPage = lazyLoad(
  () => import('./index'),
  module => module.TeamsPage,
);
